import { useState } from "react";

interface LegalEntityActivitySummaryProps {
  value: string | null | undefined;
  edited?: boolean;
  onChange?: (value: string) => void;
}

export function LegalEntityActivitySummary({
  value,
  edited = false,
  onChange,
}: LegalEntityActivitySummaryProps) {
  const summary = value?.trim() ?? "";
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");

  if (!summary && !onChange) return null;

  if (editing && onChange) {
    return (
      <div className="mt-1.5">
        <textarea
          autoFocus
          aria-label="What this entity does"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          className="h-14 w-full resize-none rounded-lg bg-muted px-2 py-1.5 text-[10.5px] outline-none"
        />
        <div className="mt-1 flex justify-end gap-1.5">
          <button
            type="button"
            onClick={() => setEditing(false)}
            className="text-[9px] text-muted-foreground/70 hover:text-foreground"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              const nextValue = draft.trim();
              if (nextValue) onChange(nextValue);
              setEditing(false);
            }}
            className="rounded-md bg-foreground px-2 py-0.5 text-[9px] font-medium text-background"
          >
            Save
          </button>
        </div>
      </div>
    );
  }

  const content = (
    <>
      {summary || "Description not identified"}
      {edited && (
        <span className="text-[9px] italic text-muted-foreground/70">
          , edited by you
        </span>
      )}
    </>
  );

  return (
    <section className="mt-1.5 rounded-lg bg-muted/50 px-2 py-1.5">
      <span className="text-[8.5px] font-medium uppercase tracking-wide text-muted-foreground/70">
        What this entity does
      </span>
      {onChange ? (
        <button
          type="button"
          aria-label="Edit activity description"
          onClick={() => {
            setDraft(summary);
            setEditing(true);
          }}
          className="block w-full cursor-text text-left text-[10.5px] leading-[1.45] text-foreground"
        >
          {content}
        </button>
      ) : (
        <p className="text-[10.5px] leading-[1.45] text-foreground">
          {content}
        </p>
      )}
    </section>
  );
}
